import { useEffect, useState } from 'react'
import { Bot } from 'lucide-react'
import {
  getApiClient,
  type GiftSummaryAiSdrResponse,
} from '@/lib/api'
import {
  AsOfLabel,
  ErrorRow,
  fmtInt,
  LoadingRow,
  PageHeader,
  Section,
} from './shared'

const DECISIONS: Array<{ id: string; text: string }> = [
  { id: 'D-043', text: '法人事業として継続し、40ブースまで増やす' },
  { id: 'D-043', text: 'コストは1アポあたりの金額で見る。試算は再検算中' },
  { id: 'D-044', text: '修正依頼の優先度は立花・石井・吉平で調整する' },
]

export function SummaryAiSdrPage() {
  const [data, setData] = useState<GiftSummaryAiSdrResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    void getApiClient()
      .getGiftSummaryAiSdr()
      .then((result) => {
        if (!cancelled) {
          setData(result)
          setError(false)
          setLoading(false)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError(true)
          setLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [])

  const connected = data?.dataStatus !== 'not_connected'
  const hasAiApo = (data?.aiChannelApo ?? 0) > 0

  return (
    <div className="space-y-6">
      <PageHeader title="AI-SDR" sub="AI テレアポの進捗" />

      {loading ? (
        <LoadingRow label="AI-SDR" />
      ) : error ? (
        <ErrorRow label="AI-SDR" />
      ) : (
        <>
          {!connected && (
            <Section title="未接続">
              <div className="flex items-start gap-2">
                <Bot className="mt-0.5 h-5 w-5 text-primary" aria-hidden />
                <div className="text-sm text-muted-foreground">
                  <p className="font-medium text-foreground">
                    CH には AI-SDR の計測データがまだありません
                  </p>
                  <p className="mt-1">
                    AI-SDR の計測が接続されると、以下の指標を表示します。
                  </p>
                </div>
              </div>
              <ul className="mt-3 grid gap-1 text-sm text-muted-foreground">
                <li>・日別コール数</li>
                <li>・アポ数</li>
                <li>・1アポ単価</li>
                <li>・稼働ブース数</li>
              </ul>
            </Section>
          )}

          {hasAiApo && (
            <Section title="AI 由来のアポ（今月）">
              <p className="text-2xl font-bold tabular-nums">
                {fmtInt(data?.aiChannelApo)}件
              </p>
              <p className="mt-1 text-xs text-muted-foreground">
                appo_channel 軸で「電話」「unknown」以外のアポ件数
              </p>
            </Section>
          )}

          <Section title="決定事項" note="数字は出典の決定番号つきで表示。試算額は出していません">
            <ul className="grid gap-2">
              {DECISIONS.map((d) => (
                <li
                  key={d.id + d.text}
                  className="rounded-md border bg-background px-3 py-2 text-sm"
                >
                  <span className="mr-2 font-semibold text-primary">{d.id}</span>
                  {d.text}
                </li>
              ))}
            </ul>
          </Section>

          {connected && (
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <AsOfLabel computedAt={data?.computedAt ?? null} />
            </div>
          )}
        </>
      )}
    </div>
  )
}
